import React from 'react'

export default function Close({ size = 15 }) {
	return (
		<svg width={size} height={size} viewBox="0 0 15 15">
			<polygon
				fill="currentColor"
				// eslint-disable-next-line max-len
				points="12.960933 2.76223489e-13 7.171 5.79188641 1.38302043 2.76223489e-13 2.76223489e-13 1.38106701 5.78993299 7.171 2.76223489e-13 12.960933 1.38302043 14.342 7.171 8.55206701 12.960933 14.342 14.342 12.960933 8.55206701 7.171 14.342 1.38106701"
			/>
		</svg>
	)
}
